import { createContext, useContext, useEffect, useState } from "react";
import { getT } from "@/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pp_lang") || "fr");
  useEffect(() => { localStorage.setItem("pp_lang", lang); }, [lang]);
  const t = getT(lang);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
